module.exports = __webpack_public_path__ + "e6fac1a5a90dab2af315b842e291e4fb.svg";